import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Format, If, Text } from 'src/Components'
import {
  Heading,
  ProConList,
  Pro,
  Info,
  Strong
} from 'src/Components/Gem/GemDetail'
import { rentBuy } from 'src/constants/equity'
import MonthlyPayment from 'src/features/homeowners/Components/PurchasingPower/MonthlyPayment'
import DetailLayout from 'src/features/homeowners/Components/PurchasingPower/DetailLayout'
import BuyersLink from 'src/features/homeowners/Components/PurchasingPower/BuyersLink'
import CTAHeading from 'src/features/homeowners/Components/PurchasingPower/CTAHeading'

import styles from './RentBuyDetail.module.scss'
import { FROM } from 'src/constants/navigation'
const { RENT_BUY } = FROM

const propTypes = {
  showBuyersLink: PropTypes.bool.isRequired,
  budget: PropTypes.number.isRequired,
  downPaymentAmount: PropTypes.number.isRequired,
  monthlyPayment: PropTypes.number.isRequired,
  mortgageRate: PropTypes.number.isRequired
}

const RentBuyDetail = ({
  showBuyersLink,
  monthlyPayment,
  budget,
  downPaymentAmount,
  mortgageRate
}) => (
  <DetailLayout>
    <Heading>
      <FormattedMessage
        id='Homeowner.purchasePower.rentBuyHeading'
        defaultMessage='You could take around {downPaymentAmount} of your equity and use it as a {downPaymentPercent} down payment on another home worth {budget} and rent out your current house.'
        values={{
          downPaymentAmount: (
            <Strong>
              <Format.Currency abbreviate value={downPaymentAmount} />
            </Strong>
          ),
          downPaymentPercent: (
            <Strong>
              <Format.Percentage value={rentBuy.downPaymentPercent * 100} />
            </Strong>
          ),
          budget: (
            <Strong>
              <Format.Currency abbreviate value={budget} />
            </Strong>
          )
        }}
      />
    </Heading>

    <ProConList className={styles.proCon}>
      <Pro>
        <FormattedMessage
          id='Homeowner.purchasePower.rentBuyOne'
          defaultMessage='Your new monthly payment on a {loanTerm}-year mortgage at {apr} would be around {payment}'
          values={{
            apr: <Format.Rate value={mortgageRate} />,
            loanTerm: rentBuy.loanTerm,
            payment: <MonthlyPayment value={monthlyPayment} />
          }}
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.purchasePower.rentBuyFour'
          defaultMessage='You could lease the property long-term or rent it nightly on Airbnb (Always check with a real estate agent first)'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.purchasePower.rentBuyThree'
          defaultMessage='Use rental income to cover some or all of your original mortgage payment'
        />
      </Pro>
      <Info>
        <FormattedMessage
          id='Homeowner.purchasePower.rentBuyFive'
          defaultMessage='Consider whether you have time to be a landlord (or should hire a property manager)'
        />
      </Info>
    </ProConList>

    <If condition={showBuyersLink}>
      <CTAHeading className={styles.cta}>
        <FormattedMessage
          id='Homeowner.purchasePower.rentBuyCTA'
          defaultMessage='Find your new home'
        />
      </CTAHeading>
      <Text align='center'>
        <BuyersLink affordability={budget} from={RENT_BUY}>
          <FormattedMessage
            id='Homeowner.purchasePower.explore'
            defaultMessage='Start your search'
          />
        </BuyersLink>
      </Text>
    </If>
  </DetailLayout>
)

RentBuyDetail.propTypes = propTypes

export default RentBuyDetail
